// SEABORN_BRIGHT
export const DEFAULT_PALETTE: Palette = [
  '#ff7c00', // orange
  '#1ac938', // green
  '#e8000b', // red
  '#8b2be2', // purple
  '#9f4800', // brown
  '#f14cc1', // pink
  '#ffc400', // khaki
  '#00d7ff', // cyan
  '#023eff'  // blue
];

export type Palette = string[];